<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16I9waF/images/cover.jpg?1692134978094" alt="This image is the cover for the book Constructing Paul (The Canonical Paul, vol. 1)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Constructing Paul (The Canonical Paul, vol. 1)
      </h1>
      <p class="bookDescription body article font2">
        <p>First of a two-volume work providing a framework for understanding the life and thought of the apostle Paul</p><p>In this methodological tour de force, Luke Timothy Johnson offers an articulate, clear, and thought-provoking portrait of the life and thought of the apostle Paul.</p><p>Drawing upon recent developments in the study of Paul, Johnson offers readers an invitation to the Apostle Paul. Rather than focusing on a few of Paul’s letters, Johnson lays out the materials necessary to envision the apostle from the thirteen canonical letters of Paul and the Acts of the Apostles. <i>Constructing Paul</i> thus provides a framework within which an engagement with Paul’s letters can take place. Johnson demonstrates the possibility of doing responsible and creative work across the canonical collection without sacrificing literary or historical integrity.</p><p>By bringing out the facets of the apostle from the canonical evidence, Johnson shows the possibilities for further and better inquiry into the life and thought of Paul. This first volume imagines a plausible biography for Paul and serves as an introduction to the studies in the second volume. <i>Constructing Paul</i> addresses all the pertinent questions related to the study of Paul. Johnson uses the canonical material as building blocks to make a case for why Paul ought to be heard today as a liberating rather than oppressing voice.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Luke Timothy Johnson
      </h2>
      
      <p class="authorDescription body article">&#160;<B>Luke Timothy Johnson</B>&#160;is the Robert W. Woodruff Professor Emeritus of New Testament and Christian Origins at Candler School of Theology, Emory University. He won the 2011 Grawemeyer Award in Religion for his&#160;<I>Among the Gentiles: Greco-Roman Religion and Christianity</I>. Johnson&#39;s many other books include&#160;<I>The Revelatory Body; Brother of Jesus, Friend of God</I>; and&#160;<I>The Writings of the New Testament.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6affcedc